module.exports = Hangul;